// Code Assistant Prompts
export const CODE_ASSISTANT_PROMPTS = {
  // Main code assistant system prompt
  mainPrompt: (code) => `You are a helpful coding assistant. The user has a code editor open with the following code:

\`\`\`
${code}
\`\`\`

When answering questions, always consider the context of this code. If asked to make changes, provide the updated code in full. If asked to explain something, reference specific line numbers.`,

  // Intent classification prompt
  intentClassification: (userMessage, code) => `Given the following user message and code context, classify the user's intent.

User message: "${userMessage}"

Code context:
\`\`\`
${code}
\`\`\`

Classify the intent as one of:
- OPTIMIZATION: User wants to optimize/improve the code
- SCORING: User wants to know code quality scores/metrics
- GENERAL: Any other coding question or request

Respond with only the classification word.`,

  // Dynamic metrics generation prompt
  dynamicMetrics: (code) => `Analyze the following code and generate 5 context-specific quality metrics that would be most relevant for this particular code.

Code:
\`\`\`
${code}
\`\`\`

For each metric, provide:
1. A short name (e.g., "Error Handling")
2. A score from 0-100
3. A brief explanation of what the metric measures
4. One specific suggestion for improvement

Format your response as a JSON array of objects with properties: name, score, explanation, suggestion.`,

  // Optimization approaches prompt
  optimizationApproaches: (language) => `For ${language} code optimization, suggest 3 different optimization approaches. For each approach:

1. Give it a clear name
2. Provide a brief description
3. List 2-3 specific techniques it would use
4. Indicate the difficulty level (Easy/Medium/Hard)
5. Estimate the potential performance improvement (Low/Medium/High)

Format as a JSON array.`,

  // Code analysis prompt
  codeAnalysis: (code, metrics = []) => `Analyze the following code based on these quality metrics:

Code:
\`\`\`
${code}
\`\`\`

Metrics to evaluate:
${metrics.length > 0 ? metrics.map(m => `- ${m.name}: ${m.explanation}`).join('\n') : 'No specific metrics provided'}

Provide:
1. A score (0-100) for each metric
2. Overall code quality assessment
3. Top 3 specific improvements with code examples
4. Any security concerns

Be specific and reference line numbers where applicable.`,

  // Optimization template
  optimizationTemplate: (code, approach) => `Optimize the following code using the "${approach}" approach:

\`\`\`
${code}
\`\`\`

Provide:
1. The optimized code in full
2. A list of specific changes made
3. Expected performance improvements
4. Any trade-offs or considerations

Focus on practical improvements that maintain readability.`
};

// Additional code-related prompts
export const CODE_PATTERNS = {
  errorHandling: 'Analyze error handling patterns and suggest improvements',
  performance: 'Identify performance bottlenecks and optimization opportunities',
  security: 'Check for security vulnerabilities and suggest fixes',
  readability: 'Evaluate code readability and suggest improvements',
  testing: 'Suggest unit tests for the given code',
  documentation: 'Generate documentation for the code',
  refactoring: 'Suggest refactoring opportunities to improve code structure'
};